export const currencyFormatter = (amount: number) => {
    return amount?.toFixed(2)?.replace(/\B(?=(\d{3})+(?!\d))/g, ",") || "0.00";
}
